import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientVacanciesPage from "@/pages/client/ClientVacanciesPage";

export const Route = createFileRoute("/client/vacancies")({
  head: () => pageHead("Client · Vacancies", "AKIVA client · vacancies portal.", "/client/vacancies", true),
  component: ClientVacanciesPage,
});
